import { BuyInputField } from './buy-input'
import { Index } from 'hooks/type-of-use-indices'
import React from 'react'
import { SellInputField } from './sell-input'
import { useTransactionalContext } from '../transactional-context'

export interface InputProps {
  indexInfo: Index
  finishedLoading: boolean
}
export const InputField: React.FC<InputProps> = ({ indexInfo, finishedLoading }) => {
  const { isBuying } = useTransactionalContext()
  const content = isBuying ? (
    <BuyInputField indexInfo={indexInfo} finishedLoading={finishedLoading} />
  ) : (
    <SellInputField indexInfo={indexInfo} />
  )
  return content
}
